var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b({}, "div", _vm.navAttributes, false),
    [
      _c("tree-view", {
        attrs: {
          model: _vm.model,
          "root-attributes": _vm.rootAttributes,
          "root-child-attributes": _vm.rootChildAttributes,
          "render-root-child-tag": true,
          "render-child-tag": true,
          "root-tag": "b-nav",
          "root-child-tag": "b-nav-item-dropdown",
          "parent-tag": "ul",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (item) {
              return _c("nav-menu-item", {
                attrs: { item: item.item, depth: item.depth },
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }